import React, { FC } from 'react';
import { IAnetaPacks } from 'types';
import AnetaPacksListItem from '../AnetaPacksItem';
import anetaPackBags from '../anetaPackBags';

interface ListProps {
  posts: IAnetaPacks[];
  openNext: () => void;
  handleClose: () => void;
  handleChooseAnetapack?: (pack: IAnetaPacks) => void;
  searchValue: string;
}

const AnetaPackList: FC<ListProps> = ({
  posts,
  openNext,
  handleClose,
  searchValue,
  handleChooseAnetapack,
}) => {
  return (
    <>
      {posts.map((item, idx: number) => {
        const bagData = anetaPackBags.find((el, i: number) => {
          return idx % anetaPackBags.length === i && el;
        });
        return (
          item.name.toLowerCase().includes(searchValue.toLowerCase()) && (
            <AnetaPacksListItem
              openNext={openNext}
              handleClose={handleClose}
              data={item}
              key={item.id}
              bagData={bagData}
              active
              handleChooseAnetapack={handleChooseAnetapack}
            />
          )
        );
      })}
    </>
  );
};

export default AnetaPackList;
